import { Application } from '@hotwired/stimulus';

import * as security from '../core/utils/security';

security.patchDocumentHeadAppendChildWithCspStyleNonce();

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;

window.Stimulus = application;

export { application };
